import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="m20.03 5.385-8.37 8.37 2.605 6.657c.1.256.465.25.555-.01l5.21-15.017Zm-9.784 6.956 8.37-8.37L3.599 9.18a.296.296 0 0 0-.011.554l6.658 2.606ZM19.549 1.53C21.361.9 23.1 2.64 22.471 4.45l-5.762 16.606c-.699 2.016-3.53 2.07-4.307.084l-2.636-6.739a.296.296 0 0 0-.168-.167l-6.739-2.637C.872 10.82.928 7.99 2.943 7.29L19.55 1.53Z"
  />,
  'Send1'
)
